import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledAlertError = styled('div')(
  () => css`
    .alert-error {
      background-color: #ffecef;
      padding: 18px 24px;
      margin-top: 8px;
      box-sizing: border-box;
      .icon {
        padding: 13px;
        background-color: #f1606310;
        border-radius: 50%;
        font-size: 1.375rem;
      }
      .more-details {
        cursor: pointer;
      }
    }
  `
);
